const js = {}; export default js;
const imp_nbxw623t = {}; export { imp_nbxw623t as hooks };
import js_o54ugub22xpla6vdtwpdzs26wq from "./PricesWeb.Offer.Address/94_ois55nxu76mecarldetfirpgsu.js"; imp_nbxw623t["PricesWeb.Offer.Address.InvoiceVatRequired"] = js_o54ugub22xpla6vdtwpdzs26wq;
